<template>
  <div class="relative">
    <swiper
      ref="mySwiper"
      :options="swiperOption"
      class="h-full"
    >
      <swiper-slide
        v-for="(image, index) in post.gallery"
        :key="`swiper-slide-${index}`"
        :data-background="image.sizes.large"
        class="swiper-lazy bg-cover bg-center"
      >
        <span
          role="img"
          :aria-label="image.alt"
        />
        <div class="swiper-lazy-preloader" />
      </swiper-slide>
    </swiper>

    <div class="absolute bottom-0 min-h-8 md:min-h-12 bg-white opacity-90 z-10 px-1vw lg:py-3 flex items-center justify-between w-full">
      <button
        @click="slidePrev"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="32" viewBox="0 0 59 32" v-bind:svg-inline="''" v-bind:class="'fill-current text-primary h-3 w-3 md:h-6 md:w-6 rotate-90'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M58.471 1.402l-.937-.937a1.583 1.583 0 00-2.244 0L29.477 26.289 3.653.465a1.583 1.583 0 00-2.244 0l-.937.937a1.583 1.583 0 000 2.244l27.876 27.876a1.583 1.583 0 002.244 0L58.468 3.646a1.573 1.573 0 00.003-2.245z"/></svg>
      </button>
      <p
        class="text-sm md:text-base mx-6 text-center"
      >
        <span class="font-bold">{{ swiperSlideInfo.active }}/{{ swiperSlideInfo.total }}</span> - {{ post.gallery[swiperSlideInfo.active -1].title }}
      </p>
      <button
        @click="slideNext"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="32" viewBox="0 0 59 32" v-bind:svg-inline="''" v-bind:class="'fill-current text-primary h-3 w-3 md:h-6 md:w-6 rotate-270'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M58.471 1.402l-.937-.937a1.583 1.583 0 00-2.244 0L29.477 26.289 3.653.465a1.583 1.583 0 00-2.244 0l-.937.937a1.583 1.583 0 000 2.244l27.876 27.876a1.583 1.583 0 002.244 0L58.468 3.646a1.573 1.573 0 00.003-2.245z"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'Gallery',

  components: {
    swiper,
    swiperSlide
  },

  props: {
    post: {
      type: Object,
      default: () => []
    }
  },

  data() {
    return {
      swiperSlideInfo: {
        active: 1,
        total: this.post.gallery.length
      },
      swiperOption: {
        preloadImages: false,
        loadPrevNext: true,
        lazy: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        mousewheel: true,
        loop: true,
        on: {
          slideChange: () => {
            this.$nextTick(() => {
              this.getSwiperSlideInfo()
            })
          }
        }
      }
    }
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },

  methods: {
    slideNext() {
      this.swiper.slideNext()
    },
    slidePrev() {
      this.swiper.slidePrev()
    },
    getSwiperSlideInfo() {
      this.swiperSlideInfo = { active: this.swiper.realIndex + 1, total: this.post.gallery.length }

      window.dataLayer.push({
        event: 'galleryProgressUpdate',
        galleryProgress: `${this.swiper.realIndex + 1}/${this.post.gallery.length}`
      })
    }
  }
}

</script>
